/**
 * 钉钉应用信息
 */
export default {
  state: 'STATE',
  response_type: 'code',
  scope: 'snsapi_login',
  scope_auth: 'snsapi_auth',
  loginTmpCode: 'loginTmpCode',
  appid: 'dingaxswfwp9xbqnmc1s',
  corpId: "dinga82d06492e33351d35c2f4657eb6378f",
  redirect_uri: `${window.location.origin}/auth-redirect`, 
  AuthorizeUrl: 'https://oapi.dingtalk.com/connect/oauth2/sns_authorize',
}

